import { fromPlacementId } from '../../combination-rules/placementIds'
import { EmbroiderySelections } from '../../types'
import { EmbroideryItem } from '../types'

/**
 * Flattens selected items into the shape the old provider handed the cart: one text, one icon,
 * and one logo, keyed by embroidery type. If a garment somehow carries two items of the same
 * type, the last one wins.
 *
 * Reconstructs `EmbroideryProvider.tsx`'s `embroiderySelectionsEnabledForBag`, which
 * `generateEmbroideryLineItemProperties` (the cart-attribute builder) expects.
 */
export const legacySelectionsFromItems = ({
  items,
}: {
  items: readonly EmbroideryItem[]
}): EmbroiderySelections => {
  const selections: EmbroiderySelections = {}

  items.forEach(item => {
    const placement = fromPlacementId(item.placementId)

    switch (item.typeKey) {
      case 'text':
        selections.textFirstLine = item.values.firstLine
        selections.textSecondLine = item.values.secondLine
        selections.textFont = item.values.font
        selections.textColor = item.values.threadColor
        selections.textPlacement = placement
        break
      case 'icon':
        selections.iconDesignFile = item.values.icon?.designFile
        selections.iconDesignName = item.values.icon?.image.label
        selections.iconImageSource = item.values.icon?.image.src
        selections.iconPlacement = placement
        break
      case 'logo':
        selections.logoFile = item.values.logoFile
        selections.logoId = item.values.logoFile?.id
        selections.logoName = item.values.logoFile?.name
        selections.logoNote = item.values.logoFile?.notes ?? undefined
        selections.logoPreview = item.values.logoFile?.preview
        selections.logoColor = item.values.logoFile?.digitizationSetting
        selections.logoPlacement = placement
        break
    }
  })

  return selections
}
